import React from 'react'
import { observer } from 'mobx-react';;
import './ScreeningSorting.less';
import autobind from 'autobind-decorator';
import classnames from 'classnames';
import store from '../../store'

export interface ScreeningSortingPropType {
    prefixCls?: string;
    style?: any;
    tabArr?: any[];
    onSortsClick?: (index?: number, sort?: string) => void;
}


export interface ScreeningSortingState {
    tabIndex: number;
    sortFlag: string;
}

/**
 * 筛选排序组件
 * @class ScreeningSorting
 * @extends {React.Component<ScreeningSortingPropType, ScreeningSortingState>}
 */
@observer
class ScreeningSorting extends React.Component<ScreeningSortingPropType, ScreeningSortingState> {
    static defaultProps = {
        prefixCls: 'screening-sorting',
        tabArr: [{
            title: '综合',
            icon: false
        }, {
            title: '销量',
            icon: false
        }, {
            title: '最新',
            icon: false
        }, {
            title: '价格',
            icon: true
        }]
    };

    state = {
        tabIndex: 0, // 切换索引
        sortFlag: ''
    };
    componentWillMount() {
        let tabIndex = store.searchsort.tabIndex;
        !tabIndex && store.searchsort.setTabIndex(0);
    }
    // 排序点击事件 升序：asc 降序：desc
    @autobind
    onSortsClick(tabIndex) {
        let tabIndexStore = store.searchsort.tabIndex;
        if (tabIndex == 3) {
            let sortFlag = store.searchsort.sortFlag
            if (sortFlag == 'desc') {
                store.searchsort.setSortFlag('asc')
            } else if (sortFlag == 'asc') {
                store.searchsort.setSortFlag('desc')
            }
            if (tabIndex != tabIndexStore) {
                store.searchsort.setSortFlag('asc')
            }
        } else {
            store.searchsort.setSortFlag('')
        }
        //存入tabIndex
        store.searchsort.setTabIndex(tabIndex);
        //传参
        let sortFlag = store.searchsort.sortFlag
        if (this.props.onSortsClick) {
            this.props.onSortsClick(tabIndex, sortFlag);
        }
    }

    @autobind
    _showTab() {
        const { tabArr = [], prefixCls } = this.props;
        let tabIndex = store.searchsort.tabIndex;
        let sortFlag = store.searchsort.sortFlag;
        let len: number = tabArr.length;
        return tabArr.map((value, index) => {
            let cls: any = classnames(`${prefixCls}-sorts`, tabIndex === index ? `${prefixCls}-sorts-active` : ``);
            let ascending: any = classnames(`${prefixCls}ascending`, sortFlag === 'asc' ? `${prefixCls}ascending-active` : ``);
            let descending: any = classnames(`${prefixCls}descending`, sortFlag === 'desc' ? `${prefixCls}descending-active` : ``);

            return (
                <div className={cls}
                    style={{ width: 100 / len + '%' }} key={index} onClick={() => {
                        this.onSortsClick(index);
                    }}>
                    {value.title}
                    <div className={`${prefixCls}-line`} />
                    {
                        value.icon && <div className={`${prefixCls}-sorter`}>
                            <i className={ascending}>
                                <svg viewBox="0 0 1024 1024" width="1em" height="1em"
                                    fill="currentColor">
                                    <path
                                        d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
                                </svg>
                            </i>
                            <i className={descending}>
                                <svg viewBox="0 0 1024 1024" width="1em" height="1em"
                                    fill="currentColor">
                                    <path
                                        d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" />
                                </svg>
                            </i>
                        </div>
                    }
                </div>
            );
        });
    }

    render() {
        const { prefixCls } = this.props;
        return (
            <div className={`${prefixCls} clearfix`}>
                {this._showTab()}
            </div>
        );
    }
}

export default ScreeningSorting;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/screeningSorting/ScreeningSorting.tsx